// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__16jeV","total":"Cart_total__jzYYP","actions":"Cart_actions__3wVpY","button--alt":"Cart_button--alt__AnLj6"};